export default "__VITE_ASSET__6V$m_5Sn__"